import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { decideFileType, showFileName } from '../utils';

const PDFPreview = dynamic(() => import('global/PDFPreview'), { ssr: false });

interface DocumentContainerProps {
  documents: string[];
  maxHeight?: string;
  dataCyName?: string;
}

function DocumentContainer({
  documents,
  maxHeight = '480px',
  dataCyName = '',
}: DocumentContainerProps) {
  const [previewPdf, setPreviewPdf] = useState(null);

  useEffect(() => {
    const pdfFiles = documents.filter(
      (doc) => decideFileType(doc) === 'file-pdf',
    );

    if (pdfFiles.length > 0) {
      setPreviewPdf(pdfFiles[pdfFiles.length - 1]);
    }
  }, [documents]);

  if (previewPdf) {
    return (
      <div data-cy={dataCyName}>
        <PDFPreview src={previewPdf} maxHeight={maxHeight} />
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '16px' }} data-cy={dataCyName}>
      {documents.map((doc) => (
        <Flex>
          <IconWrapper>
            <Iconmoon className="icon-compose_file" />
          </IconWrapper>
          <Text
            as="a"
            color={color.primary}
            href={doc}
            onClick={(e) => e.stopPropagation()}
          >
            {showFileName(doc)}
          </Text>
        </Flex>
      ))}
    </div>
  );
}

export default DocumentContainer;
